<div class="card">
  @if (field.props?.label !== undefined && field.props?.label!.length > 0) {
  <h4>{{field.props?.label}}</h4>
  }

  @for(element of model[getKey(field)]; track $index){
  <div class="card-body">
    <form [formGroup]="forms[$index]">
      <formly-form [form]="forms[$index]" [fields]="getCachedFields(element.option, $index)" [model]="element.data"></formly-form>
    </form>
    @if(!formState.readMode){
    <div>
      <button type="button" class="btn btn-sm btn-danger" (click)="removeSection($index)">Remove</button>
    </div>
    }
    <hr>
  </div>
  }
  @if (!formState.readMode){
  <sas-select [label]="''" name="selectSection" [(model)]="optionSelected" [sasOptions]="getSelectOptions(field.props?.options)" (sasOnSelect)="selectOption(optionSelected)">
  </sas-select>
  }
  @if(multiple && !formState.readMode){
  <button type="button" class="btn btn-primary" (click)="addNew()">{{ btnText }}</button>
  }
</div>
